module.exports = __webpack_public_path__ + "static/img/interactionLive05.3281f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interactionLive05.png
// module id = RESH
// module chunks = 0